import {ExternalLink} from '@nlabs/gothamjs/icons';

import {shopProductPromotions} from '../data/shopProducts';

export const ShopPromotion = () => (
  <aside aria-label="Advertisement from the NitrogenX shop" className="shell shop-promotion">
    <header className="shop-promotion__header">
      <div><span>Advertisement</span><h2>From the Nitrogen Studios Shop</h2></div>
      <a href="https://shop.nitrogenx.co" rel="noreferrer sponsored" target="_blank">Visit the shop<ExternalLink aria-hidden="true" size={14} /></a>
    </header>
    <div className="shop-promotion__grid">
      {shopProductPromotions.map((product) => (
        <a className="shop-product" href={product.url} key={product.url} rel="noreferrer sponsored" target="_blank">
          <img alt={product.name} decoding="async" loading="lazy" src={product.imageUrl} />
          <span>{product.name}</span>
          <strong>Shop product<ExternalLink aria-hidden="true" size={13} /></strong>
        </a>
      ))}
    </div>
  </aside>
);
